import React from 'react';
import {withRouter} from "react-router";
import {Link} from 'react-router-dom';

import {Button} from "reactstrap";
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import ReCAPTCHA from "react-google-recaptcha";

import API from "@beardeddevops/react.api";
import APPCONFIG from 'constants/Config';
import Framework from "@beardeddevops/react.framework";
import Types from "constants/Types";
import {locationHasModule} from "../../../components/Utilities";

/**
 *  @property {Accounts_Object} state
 *  @property {object} model
 *  @property {Accounts_Properties} model.properties
 *  @property {Accounts_Is} model.is
 *  @property {Accounts_Has} model.has
 */
class Login extends Framework.Components.Object {

	constructor(props) {
		super(props, Types.Accounts._name);
		this.model.requestType = API.RequestType.READ;
		this.recaptchaRef = React.createRef();
		this.brand = APPCONFIG.brand;
		this.shouldAutoLoad = false;
		this.state.requires_2fa = false;
		this.state.two_step_method = '';
		this.state.two_step_message = '';
		this.state.two_step_code = '';
		this.state.two_step_error = '';
		this.state.turnstile_token = '';
		this.turnstileWidgetId = null;

	}

	


	handleSubmit = async event => {
		if (typeof event !== 'undefined') event.preventDefault();
		// if (APPCONFIG.settings.isProductionAPI()) {
		// 	this.state.g_recaptcha_response = this.recaptchaRef.current.getValue();
		//
		// 	//bypass recaptcha for Dev
		// 	let url = window.location.href;
		// 	if(url === "https://app.fflboss.com/login") {
		// 		if (!this.state.g_recaptcha_response) {
		// 			return false;
		// 		}
		// 	}
		// }
		this.setState({loading: true});
		if (this.handleProcess(null, API.RequestType.READ)) {
			//if they toggled yes for kiosk, it will pop up the kiosk mode modal that's in NavLeftList componentDidMount
			window.localStorage.setItem('kioskLogin', this.state.kiosk);

			let data;
			try {
				data = await this.model.submit(this, API.RequestType.READ);
			} catch (error) {
				this.resetTurnstileChallenge();
				return false;
			}

			if (data.requires_2fa) {
				this.removeTurnstileChallenge();
				this.setState({
					loading: false,
					requires_2fa: true,
					two_step_method: data.method || 'authenticator',
					two_step_message: data.message || 'Verification code required.',
					two_step_code: '',
					two_step_error: '',
				});
				return false;
			}

			//if module acquisitions, take them to one_page, else dashboard
			if (data.manual_module_4473) {
				this.props.history.push('/dispositions/one_page');
			} else {
				this.props.history.push('/dashboard');
			}

		} else {
			this.setState({loading: false});
		}
		return false;
	};

	handleTwoStepSubmit = async event => {
		if (typeof event !== 'undefined') event.preventDefault();
		this.setState({loading: true, two_step_error: ''});

		try {
			this.model.object.two_step_code = this.state.two_step_code;
			let data = await this.model.submit(this, 'POST_TWO_STEP', true);

			if (data.manual_module_4473) {
				this.props.history.push('/dispositions/one_page');
			} else {
				this.props.history.push('/dashboard');
			}
		} catch (error) {
			this.setState({loading: false, two_step_error: error.message});
		}

		this.model.object.two_step_code = '';
		return false;
	};

	onChange = () => {
	};

	// noinspection JSMethodCanBeStatic
	onExpired() {
	}

	componentDidMount() {
		super.componentDidMount();
		if (window.turnstile) {
			this.renderTurnstile();
			return;
		}
		const turnstileScript = document.createElement("script");
		turnstileScript.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
		turnstileScript.defer = true;
		turnstileScript.onload = this.renderTurnstile;
		document.head.appendChild(turnstileScript);
	}

	componentWillUnmount() {
		super.componentWillUnmount();
		this.removeTurnstileChallenge();
	}


	// Test Manual Required Check: sitekey: "3x00000000000000000000FF"
	//Test Forced Failure: sitekey: "2x00000000000000000000AB"
	renderTurnstile = () => {
		if (!this._ismounted || !window.turnstile || !document.querySelector("#turnstile-widget") || this.turnstileWidgetId !== null) {
			return;
		}

		this.turnstileWidgetId = window.turnstile.render("#turnstile-widget", {
			sitekey: APPCONFIG.turnstile,
			action: "login",
			callback: (token) => {
				this.setState({turnstile_token: token});
			},
			"error-callback": (errorCode) => {
				console.error("Turnstile error:", errorCode);
				this.setState({turnstile_token: ''});
			},
			"expired-callback": () => this.setState({turnstile_token: ''}),
		});
	};

	resetTurnstileChallenge = () => {
		if (window.turnstile && this.turnstileWidgetId !== null) {
			window.turnstile.reset(this.turnstileWidgetId);
		}
		this.setState({turnstile_token: '', loading: false});
	};

	removeTurnstileChallenge = () => {
		if (window.turnstile && this.turnstileWidgetId !== null) {
			window.turnstile.remove(this.turnstileWidgetId);
		}
		this.turnstileWidgetId = null;
	};

	handleTwoStepBack = () => {
		this.setState({
			requires_2fa: false,
			two_step_method: '',
			two_step_message: '',
			two_step_code: '',
			two_step_error: '',
			turnstile_token: ''
		}, this.renderTurnstile);
	};

	handleKeyPress = (event) => {
		if (event.key === 'Enter') {
			if (this.state.requires_2fa) {
				this.handleTwoStepSubmit();
			} else if (this.state.turnstile_token) {
				this.handleSubmit();
			}
		}
	}

	render() {
		/** @type {Accounts_Properties} properties */
		let properties = this.model.properties;
		/** @type {Accounts_Object} object */
		let object = this.state;
		let brand = this.brand;
		return (
			<div className="body-inner"
				tabIndex={0}
				onKeyDown={this.handleKeyPress}>
				<Card>
					<CardContent style={{paddingBottom: 0}}>
						<section className="logo text-center">
							<h1>{brand}</h1>
						</section>

						{object.requires_2fa ?
							<fieldset>
								<div className="form-group">
									<label>{object.two_step_method === 'email' ? 'Email Verification Code' : 'Authenticator Code'}</label>
									{object.two_step_message && <div style={{marginBottom: '10px'}}>{object.two_step_message}</div>}
									<input
										className="form-control"
										value={object.two_step_code}
										onChange={event => this.setState({
											two_step_code: event.target.value.replace(/\D/g, '').slice(0, 6),
											two_step_error: ''
										})}
									/>
									{object.two_step_error && <div className="text-danger">{object.two_step_error}</div>}
								</div>
								<br/>
							</fieldset>
							:
							<fieldset>
							<div className="form-group">
								<Framework.Elements.TextField
									value={object.email}
									error={object.email_error}
									property={properties.email}
									update={this.handleTextFieldPropertyUpdate}
									variant={"standard"}
								/>
							</div>
							<br/>
							<div className="form-group">
								<Framework.Elements.TextField
									value={object.password}
									error={object.password_error}
									property={properties.password}
									update={this.handleTextFieldPropertyUpdate}
									variant={"standard"}
									type={"password"}
								/>
							</div>
							<br/>
								<div id="turnstile-widget"></div>
						</fieldset>}

						{!object.requires_2fa && <div className={'form-group'}>
							<div>
								<span>Log in to Kiosk-Mode</span>
								<div style={{float: 'right'}}>
									<Framework.Elements.ButtonSwitch
										property={properties.kiosk}
										value={object.kiosk}
										error={object.kiosk_error}
										update={this.handleTextFieldPropertyUpdate}
									/>
								</div>
							</div>
							<br/>
						</div>}

						{!object.requires_2fa && APPCONFIG.settings.isProductionAPI() &&
						<div style={{textAlign: 'center', paddingTop: '10px'}} data-cy={"recaptcha"}>
							{/*<ReCAPTCHA*/}
							{/*	ref={this.recaptchaRef}*/}
							{/*	sitekey={window.Cypress ? "6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI" : APPCONFIG.reCAPTCHA}*/}
							{/*	onChange={this.onChange}*/}
							{/*	name={"recaptcha"}*/}
							{/*	onExpired={this.onExpired.bind(this)}*/}
							{/*	style={{*/}
							{/*		display: 'inline-block'*/}
							{/*	}}*/}
							{/*/>*/}
						</div>}

					</CardContent>
						<CardActions className={'justify-content-between align-items-end'}>
							{object.requires_2fa &&
								<Button
									onClick={this.handleTwoStepBack}
									color="secondary"
									size={"md"}
									block={false}>Back</Button>}
						<Button
							onClick={object.requires_2fa ? this.handleTwoStepSubmit : this.handleSubmit}
							type={"submit"}
							id={"button-login"}
							color="primary"
							size={"md"}
							disabled={object.requires_2fa ? object.two_step_code.length !== 6 : !object.turnstile_token}
							block={false}>{object.requires_2fa ? 'Verify' : 'Login'}</Button>
					</CardActions>
				</Card>
				<div className="additional-info">
					<span style={{'color': '#909090'}}>Version {process.env.version} | {APPCONFIG.copyright}-{APPCONFIG.year} © <a className="brand" target="_blank" href={APPCONFIG.productLink} style={{'color': '#525252'}}>{APPCONFIG.brand}</a></span>
					<br/>
					<Link to="/register" style={{'color': '#525252'}}>Sign up</Link>
					<span className="divider-h" style={{'borderRightColor': '#525252'}}/>
					<Link to="/forgot-password" style={{'color': '#525252'}}>Forgot your password?</Link>
				</div>

			</div>
		);
	}
}

const LoginRoute = withRouter(Login);
const Page = () => (
	<div className="page-login">
		<div className="main-body">
			<div key="1">
				<LoginRoute/>
			</div>
		</div>
	</div>
);

export default Page;
